import { Injectable, Injector } from '@angular/core';
import { Namespace } from 'enums-lib';
import { ISharedServiceProviderService } from 'interfaces-lib';
import { BullhornSharedServiceProviderService } from './bullhorn-shared-service-provider.service';
import { InveniasSharedServiceProviderService } from './invenias-shared-service-provider.service';
import { SalesforceSharedServiceProviderService } from './salesforce-shared-service-provider.service';
import { SectionSharedServiceProviderService } from './section-shared-service-provider.service';

@Injectable({ providedIn: 'root' })
export class SharedServiceProviderServiceFactory {
  constructor(private injector: Injector) {
  }

  getServiceProviderService(namespace?: string | Namespace): ISharedServiceProviderService {
    if (namespace === Namespace.invenias) {
      return this.injector.get(InveniasSharedServiceProviderService);
    }
    if (namespace === Namespace.bullhorn) {
      return this.injector.get(BullhornSharedServiceProviderService);
    }
    if (namespace === Namespace.salesforce) {
      return this.injector.get(SalesforceSharedServiceProviderService);
    }
    if (namespace === Namespace.section) {
      return this.injector.get(SectionSharedServiceProviderService);
    }

    throw new Error(`No service provider service found for '${namespace}'`);
  }
}
